import Shaka from 'shaka-player/dist/shaka-player.ui'

class ManifestMenu extends Shaka.ui.Element {
  constructor(parent, controls, manifests) {
    super(parent, controls);

    this.manifests = manifests;

    this.controlsContainer_ = this.controls.getControlsContainer();

    this.addManifestMenuButton_();
    this.addManifestMenu_();
    this.updateManifestSelection_(0);

    this.eventManager.listen(this.manifestMenuButton_, 'click', () => {
      this.onManifestMenuButtonClick_();
    });
  }

  /**
   * @private
   */
  addManifestMenuButton_() {
    this.manifestMenuButton_ = document.createElement('button');
    this.manifestMenuButton_.id = 'manifest-menu-button';
    this.manifestMenuButton_.classList.add('shaka-no-propagation');
    this.parent.appendChild(this.manifestMenuButton_);
  }

  /**
   * @private
   */
  addManifestMenu_() {
    this.manifestMenu_ = document.createElement('div');
    this.manifestMenu_.classList.add('shaka-overflow-menu');
    this.manifestMenu_.classList.add('shaka-no-propagation');
    this.manifestMenu_.classList.add('shaka-show-controls-on-mouse-over');
    this.manifestMenu_.classList.add('shaka-settings-menu');

    // ".shaka-resolutions span" の CSS を借りるため、クラスを付与
    this.manifestMenu_.classList.add('shaka-resolutions');

    this.manifestMenu_.classList.add('shaka-hidden');
    this.controlsContainer_.appendChild(this.manifestMenu_);
  }

  /**
   * @private
   */
  updateManifestSelection_(selectedIndex) {
    this.removeAllChildren_(this.manifestMenu_);

    this.manifests.forEach((manifest, index) => {
      const isSelected = (selectedIndex === index);
      this.addManifestButton_(index, isSelected);
    });

    this.manifestMenuButton_.textContent = this.manifests[selectedIndex].name;
  }

  /**
   * @private
   */
  addManifestButton_(index, isSelected) {
    const manifestButton = document.createElement('button');

    manifestButton.addEventListener('click', () => {
      this.onManifestClick_(index);
    });

    // ".shaka-resolutions span" の CSS を借りるため、span 要素にする
    const span = document.createElement('span');
    span.textContent = this.manifests[index].name;
    manifestButton.appendChild(span);

    if (isSelected) {
      manifestButton.appendChild(this.checkmarkIcon_());
    }

    this.manifestMenu_.appendChild(manifestButton);
  }

  /**
   * @private
   */
  checkmarkIcon_() {
    const icon = document.createElement('i');
    icon.classList.add('shaka-chosen-item');

    // チェックマークアイコンを追加
    icon.classList.add('material-icons-round');
    icon.textContent = 'done';

    icon.setAttribute('aria-hidden', 'true');
    return icon;
  }

  /**
   * @private
   */
  onManifestMenuButtonClick_() {
    if (this.controls.anySettingsMenusAreOpen()) {
      this.controls.hideSettingsMenus();
    } else {
      this.manifestMenu_.classList.remove('shaka-hidden');
    }
  }

  /**
   * @private
   */
  onManifestClick_(index) {
    const manifest = this.manifests[index];
    // [NOTE]
    // マニフェストの切り替え時に pause, finish が呼ばれず、
    // 再生ログ的に last_view_point が NULL になる点に注意
    this.controls.getPlayer().load(manifest.url);
    this.updateManifestSelection_(index);
  }

  /**
   * @private
   */
  removeAllChildren_(element) {
    while (element.firstChild) {
      element.removeChild(element.lastChild);
    }
  }
}

ManifestMenu.Factory = class {
  /**
   * @param {Array<Object>} manifests
   */
  constructor(manifests) {
    this.manifests = manifests;
  }

  create(rootElement, controls) {
    return new ManifestMenu(rootElement, controls, this.manifests);
  }
};

export default ManifestMenu;
